import { DialogBackdrop, DialogPanel } from '@headlessui/react';
import ImageCropper from 'components/imageCroper';
import Modal from '.';

type Props = {
    modalOpen: boolean;
    setModalOpen: (open: boolean) => void;
    updateAvatar: (imgSrc: string) => void;
    img: string;
};
const ImageModal = ({ modalOpen, setModalOpen, updateAvatar, img }: Props) => {
    return (
        <Modal
            isOpen={modalOpen}
            onClose={() => {
                setModalOpen(false);
                document.body.style.overflow = 'initial';
            }}
        >
            <div className="mx-auto flex items-center justify-center p-5">
                <ImageCropper
                    updateAvatar={updateAvatar}
                    setModalOpen={(value) => {
                        setModalOpen(value);
                        document.body.style.overflow = 'initial';
                    }}
                    img={img}
                />
            </div>
        </Modal>
    );
};

export default ImageModal;
